import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
//import aboutSimulibIcon from "./../../images/about_simulib_logo.png";
import sceneGen from "./../../images/scene_gen_icon.png";
//import simulibIcon from "./../../images/simulib_icon.png";
//import activeToggleIcon from "./../../images/pc_cv_active_icon.png";
import kpitLogo from "./../../images/kpit_logo_new.png";
import PropTypes from 'prop-types';

class SimulibNavbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toggleState: false,
      passengerData: {},
      commercialData: {},
    };
  }

  render() {
    return (
      <nav
        className="navbar navbar-expand-lg navbar-light bg-light"
        style={{ padding: "0px" }}
      >
        <li
          className="navbar-brand"
          href="#"
          style={{ paddingLeft: "1%", margin: "0", paddingRight: "1%" }}
        >
          <Link style={{ textDecoration: "none" }} to="/navigate_new">
            <img src={kpitLogo} alt="" height="30" />
          </Link>
        </li>
        <li className="navbar-brand" href="#">
          <Link to="/navigate_new">
            <img
              src={sceneGen}
              width="175"
              height="40"
              className="d-inline-block align-top"
              alt=""
              style={{ paddingLeft: "5%" }}
            ></img>
          </Link>
        </li>
        <li
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarNavDropdown"
          aria-controls="navbarNavDropdown"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </li>
        <div className="collapse navbar-collapse" id="navbarNavDropdown">
          <div className="collapse navbar-collapse">
            <div className="navbar-nav mx-auto">
              <li
                className="navbar-brand"
                href="#"
                style={{ padding: "0px" }}
              ></li>
            </div>
            <ul className="navbar-nav">
              <li className="nav-item dropdown">
                <li
                  className="nav-link dropdown-toggle"
                  href="#"
                  id="navbarDropdownMenuLink"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <i className="fas fa-user-lock"></i>
                </li>
                <div
                  className="dropdown-menu dropdown-menu-right"
                  aria-labelledby="navbarDropdownMenuLink"
                >
                  <li className="dropdown-item" href="#">
                    Add Scenario
                  </li>
                  <li className="dropdown-item" href="#">
                    Edit Scenario
                  </li>
                  <li className="dropdown-item" href="#">
                    <Link
                      to="/view_valid_scene_data"
                      style={{ textDecoration: "none", color: "#464646" }}
                    >
                      View Scenario
                    </Link>
                  </li>
                  <li className="dropdown-item" href="#">
                    <Link
                      to="/scenario_editor"
                      style={{ textDecoration: "none", color: "#464646" }}
                    >
                      Scenario Editor
                    </Link>
                  </li>
                  <li
                    className="dropdown-item"
                    href="#"
                    onClick={this.props.logOut}
                  >
                    Logout
                  </li>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    );
  }
}
//SimulibNavbar.propTypes={
//logOut:PropTypes.string,
//match:PropTypes.string,
//dispatch:PropTypes.string,
//passengerData:PropTypes.string,
//commercialData:PropTypes.string,
//}
//SimulibNavbar.defaultProps = {
//  passengerData: {},
//  commercialData: {},
//  logOut: () => {
//    console.log("Logged Out");
//  },
//};

SimulibNavbar.propTypes={
logOut:PropTypes.string,
match:PropTypes.string,
dispatch:PropTypes.string,
passengerData:PropTypes.string,
commercialData:PropTypes.string,
}
SimulibNavbar.defaultProps= {
logOut:[],
match:[],
dispatch:[],
passengerData:[],
commercialData:[],
}

const mapStateToProps = (state) => {
  return {
    type: state.toggleState.text,
    toggleImage: state.toggleState.toggleImagePath,
  };
};

// componentDidMount() {
//     this.setState( (prevState) => {
//         if(this.props.content){
//             return{
//                 scenario_id: this.props.content.scenario_id,
//                 scenario_group_name: this.props.content.scenario_group_name,
//                 scenario_uuid: this.props.content.scenario_uuid,
//                 scenario_name: this.props.content.scenario_name
//             }
//         } else {
//             return {
//                 scenario_id: "",
//                 scenario_group_name: "",
//                 scenario_uuid: "",
//                 scenario_name: ""
//             }
//         }
//     })
// }

// onScenarioUUIDChange = (e) => {
//     const scenario_uuid = e.target.value;
//     this.setState(() => ({scenario_uuid}));
// }

// onScenarioNameChange = (e) => {
//     const scenario_name = e.target.value;
//     this.setState(() => ({scenario_name}))
// }

// onSubmit = (e) => {
//     e.preventDefault();
//     const submitValue = {
//         scenario_id: this.state.scenario_id,
//         scenario_group_name: this.state.scenario_group_name,
//         scenario_uuid: this.state.scenario_uuid,
//         scenario_name: this.state.scenario_name,
//         scenario_group_scenario_mapping_id: this.props.content.scenario_group_scenario_mapping_id,
//         sequence: this.props.content.sequence,
//         scenario_group_id: this.props.content.scenario_group_id
//     }
//     //console.log(this.state);
// //        updateScenarioGroupDetails(submitValue).then( (response)=> {
// //            console.log(response);
// //        })

//     const edit_api_url = (window.location.origin).concat('/edit')
//     const data_for_api = {
//         scenario_uuid : submitValue['scenario_uuid'],
//         scenario_description : submitValue['scenario_name']
//     }
//     editDb(edit_api_url, data_for_api).then(res => {
//         console.log("Status of updation : ", res['data']['status'])
//         if(res['data']['status'] === "Updated Successfully"){
//             this.props.dispatch(editScenarioGroupData(submitValue));
//             this.props.handleEditModalClose();
//         }

//     })

//     //this.props.dispatch(editScenarioGroupData(submitValue));
//     //this.props.handleEditModalClose();
// };

export default connect(mapStateToProps)(SimulibNavbar);
